import { useEffect, useRef } from 'react';

import { Config, GetAccountReturnType, GetConnectionsReturnType, watchAccount, watchConnections } from '@wagmi/core';

import useChainByCurrency from '@/hooks/useChainByCurrency';
import { wagmiAdapter } from '@/networks/evm';
import { useSwapContext } from '@/pages/Swap/context';

export const useWatchAccountEvents = (
  onChange: (account: GetAccountReturnType<Config>, prevAccount: GetAccountReturnType<Config>) => void
) => {
  useEffect(() => {
    const unwatch = watchAccount(wagmiAdapter.wagmiConfig, { onChange });

    return () => unwatch();
  }, []);
};

export const useWatchConnectionsEvents = (
  onChange: (connections: GetConnectionsReturnType, prevConnections: GetConnectionsReturnType) => void
) => {
  useEffect(() => {
    const unwatch = watchConnections(wagmiAdapter.wagmiConfig, { onChange });

    return () => unwatch();
  }, []);
};

export const useWatchFirstTokenSelectionChainIdEvents = (
  onChange: (chainId: number, prevChainId: number | undefined) => void
) => {
  const { tokenFrom } = useSwapContext();
  const { isEvm, chainData } = useChainByCurrency(tokenFrom);
  const currentFirstTokenChainId = chainData?.id;
  const prevChainIdRef = useRef(currentFirstTokenChainId);

  useEffect(() => {
    if (isEvm && currentFirstTokenChainId && prevChainIdRef.current !== currentFirstTokenChainId) {
      onChange(currentFirstTokenChainId, prevChainIdRef.current);
      prevChainIdRef.current = currentFirstTokenChainId;
    }
  }, [tokenFrom]);
};
